<nav
  id="navbar-main"
  class="navbar navbar-horizontal navbar-light bg-white navbar-main navbar-expand-lg navbar-light"
  style="padding: 0;"
>
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/dashboards/dashboard']">
      <img src="assets/img/brand/Scriblr_Horizontal.png" />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbar-collapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="navbar-collapse navbar-custom-collapse collapse"
      id="collapseBasic" [collapse]="isCollapsed"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a [routerLink]="['/dashboards/dashboard']">
              <img src="assets/img/brand/Scriblr_Horizontal.png" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button
              type="button"
              class="navbar-toggler"
              data-toggle="collapse"
              data-target="#navbar-collapse"
              aria-controls="navbar-collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
              (click)="isCollapsed = !isCollapsed"
            >
              <span></span> <span></span>
            </button>
          </div>
        </div>
      </div>
      <!-- Navbar links -->
      <ul class="navbar-nav align-items-center ml-md-auto">
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div
            class="pr-3 sidenav-toggler sidenav-toggler-light"
            data-action="sidenav-pin"
            data-target="#sidenav-main"
            (click)="openSidebar()"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <li class="nav-item d-sm-none">
          <!-- <a class="nav-link" (click)="openSearch()">
            <i class="ni ni-zoom-split-in"></i>
          </a> -->
        </li> 
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/projects']">Projects
            <!-- <i class="ni ni-zoom-split-in"></i> -->
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/bookmarks']">Bookmarks
            <!-- <i class="ni ni-zoom-split-in"></i> -->
          </a>
        </li>
        
      </ul>
      <hr class="d-lg-none" />
      
      <!-- User -->
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <li class="nav-item dropdown" dropdown placement="bottom-right">
          <a class="nav-link pr-0 " role="button" dropdownToggle>
            <div class="media align-items-center">
              <span class="avatar avatar-sm rounded-circle" *ngIf="afAuth.user | async as user;">
                <!-- <i class="fas fa-user"></i> -->
                <!-- <img
                *ngIf="!afAuth.user || user.photoURL"
                  alt="Image placeholder"
                  src="assets/img/theme/team-4.jpg"
                /> -->
                <img
                  *ngIf="user.photoURL"
                  alt="Image placeholder"
                  [src]="user.photoURL"
                />
              </span>
              <div class="media-body ml-2 d-none d-lg-block" style="margin-left:0 !important;">
                <ul class="nav navbar-nav navbar-right">
                  <div class="btn-group" dropdown placement="bottom right" *ngIf="afAuth.user | async as user;">
                  <button id="button-alignment" dropdownToggle type="button"
                          class="btn dropdown-toggle" aria-controls="dropdown-alignment">
                     {{ user.displayName }}<span class="caret"></span>
                  </button>
                  
                </div>
                </ul>
              </div>
            </div>
          </a>
          <div
            class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
            *dropdownMenu
          >
            <div class=" dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <a
              routerLinkActive="active"
              [routerLink]="['/profile']"
              class="dropdown-item"
            >
              <i class="ni ni-single-02"></i> <span>My profile</span>
            </a>
            <a
              routerLinkActive="active"
              [routerLink]="['/examples/user-profile']"
              class="dropdown-item"
            >
              <i class="ni ni-support-16"></i> <span>Support</span>
            </a>
            <div class="dropdown-divider"></div>
            <a (click)="signout();" class="dropdown-item">
              <i class="ni ni-user-run"></i> <span>Sign Out</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
